import { AuthStateInterface, ActionInterface } from "./types";

export const initialState: AuthStateInterface = {
  status: "loading",
  isAuthenticated: false,
  user: null,
  error: null,
};

const authReducer = (
  state: AuthStateInterface = initialState,
  action: ActionInterface
): AuthStateInterface => {
  switch (action.type) {
    case "AUTH_LOADING":
      return {
        ...state,
        status: "loading",
        error: null,
      };
    case "AUTHENTICATED":
      return {
        ...state,
        status: "authenticated",
        isAuthenticated: true,
        user: action.payload?.user || null,
        error: null,
      };
    case "UNAUTHENTICATED":
      return {
        ...state,
        status: "unauthenticated",
        isAuthenticated: false,
        user: null,
        error: action.payload?.error || null,
      };
    default:
      return state;
  }
};

export default authReducer;
